<template>
  <span class="inline-flex items-center justify-center">
    <div class="loading-spinner"></div>
    <span v-if="showText" class="ml-2 text-[12px] text-white">{{ text }}</span>
  </span>
</template>

<script setup lang="ts">
interface Props {
  text?: string;
  showText?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  text: '처리중...',
  showText: true,
});

// 디버깅용 로그
console.log('LoadingSpinner props:', {
  text: props.text,
  showText: props.showText,
});
</script>

<style scoped>
.loading-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #ffffff;
  border-top: 3px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
